export const Constants = {
  TAG_NAME: 'pop-example-basic-component',
} as const;
